const TELEMETRY_STORAGE_KEY = 'assistantTelemetryV1';
const TELEMETRY_MAX_ITEMS = 300;

function readEvents() {
  if (typeof window === 'undefined') return [];
  try {
    var raw = window.localStorage.getItem(TELEMETRY_STORAGE_KEY);
    if (!raw) return [];
    var parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function writeEvents(events) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(TELEMETRY_STORAGE_KEY, JSON.stringify(events));
  } catch (e) {}
}

export function logAssistantEvent(type, payload) {
  var event = {
    id: 'evt_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8),
    type: type || 'unknown',
    payload: payload || {},
    ts: new Date().toISOString(),
  };

  var current = readEvents();
  var next = current.concat(event);
  if (next.length > TELEMETRY_MAX_ITEMS) {
    next = next.slice(next.length - TELEMETRY_MAX_ITEMS);
  }
  writeEvents(next);

  // Logs utiles pour debug local rapide (désactivables via filtre console du navigateur).
  try {
    // eslint-disable-next-line no-console
    console.debug('[assistant-telemetry]', event.type, event.payload);
  } catch (e) {}
}

export function getAssistantTelemetryEvents() {
  return readEvents();
}

